import React from "react";
import "./../WorkBox/WorkBox.css";

const WorkBox = ({ id, image, title, desc }) => {
  return (
    <>
      <div className="work-box" id={id} style={{ height: "300px" }}>
        <img src={image} alt="" />
        <span>{title}</span>
        <p>{desc}</p>
      </div>
    </>
  );
};

export default WorkBox;
